import { ProductBeverageItem } from "@hatch-digital-nl/bravilor-storybook";
import { ProductDetailInterface } from "../../interfaces/apiV2/product/ProductDetailInterface";

export const mapProductBeveragesForDisplay = (
    beverages: ProductDetailInterface["beverages"] | undefined,
): ProductBeverageItem[] =>
    (beverages ?? []).map((beverage) => ({
        code: beverage.code,
        label: beverage.label,
        iconUrl: beverage.icon_url,
    }));
